import React, { useState } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { OpenDirectionShape, SingleDatePicker, isInclusivelyAfterDay } from 'react-dates';
import moment from 'moment';

interface DatePickerProps {
    date: any;
    onDateChange: (date: any) => void;
    label?: any;
    displayFormat?: string;
    errorMessage?: any;
    allowPreviousDate?: boolean;
    allowPastDate?: boolean;
    openDirection?: OpenDirectionShape;
    placeholder?: any;
    style?: React.CSSProperties;
    className?: string;
    rightIcon?: string;
    isEndDate?: boolean;
}

const DatePickerV2: React.FC<DatePickerProps> = (props) => {
    const [focused, setFocused] = useState(false);

    return (
        <div
            className={`input-field-wrapper datepicker-v2 ${props?.className || ''} ${props?.errorMessage ? 'datepicker-v2--error' : ''
                }`}
        >
            {/* Label — same as InputFieldV2 */}
            {props?.label && (
                <div className="input-field-label-row">
                    <label className="input-field-label">
                        {props?.label}
                    </label>
                </div>
            )}

            {/* Box — same class as InputFieldV2 */}
            <div
                style={props?.style}
                className={`input-field-box datepicker-v2__box ${focused ? 'input-field-focused' : ''
                    } ${props?.errorMessage ? 'input-field-error' : ''}`}
            >
                {props?.rightIcon && (
                    <img
                        src={props?.rightIcon}
                        alt="info"
                        className="date-icon-right"
                    />
                )}
                <SingleDatePicker
                    date={props.date || null}
                    onDateChange={props.onDateChange}
                    focused={focused}
                    onFocusChange={({ focused }) => setFocused(focused)}
                    id={props?.label || 'date_id'}
                    numberOfMonths={1}
                    small
                    displayFormat={props.displayFormat || 'DD/MM/YYYY'}
                    openDirection={props.openDirection || 'up'}
                    isOutsideRange={(date) =>
                        props?.allowPastDate
                            ? false
                            : props?.isEndDate
                                ? !props?.date?.isBefore(date, 'day')
                                : !isInclusivelyAfterDay(date, moment())
                    }
                    placeholder={props?.placeholder || 'Date'}
                    firstDayOfWeek={1}
                    readOnly
                />
            </div>

            {/* Error — same as InputFieldV2 */}
            {props?.errorMessage && (
                <span className="input-field-error-text">{props.errorMessage}</span>
            )}
        </div>
    );
};

export default DatePickerV2;